import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import PastReviews from './PastReviews';
import WriteReviews from './WriteReviews';
import Link from '../Link';

import messages from '../../locale/messages';
import { debounce } from '../../helpers/debounce';

import { LinkIndicateIcon } from '../Common/Assets/SvgComponent/commonSvgIcon';

import s from './Reviews.css';

const ReviewsByYou = (props) => {

  const [current, setCurrent] = useState('others');
  const [searchKey, setSearchKey] = useState('');

  useEffect(() => {
    const { pendingData: { refetch } } = props;
    let variables = { offset: 0 };
    refetch(variables);
  }, [pendingData])

  const handleClick = (values) => {
    const { pendingData, reviewsData } = props
    let variables = values == 'others' ? { offset: 0 } : { ownerType: values, offset: 0 },
      refetchData = values == 'others' ? pendingData?.refetch : reviewsData?.refetch;
    setCurrent(values);
    refetchData(variables)
  }


  const handleSearchChange = useCallback(debounce((values) => {
    const { reviewsData: { refetch } } = props;
    const variables = {
      searchKey: values,
      current,
      type: 'me'
    };
    setSearchKey(values);
    refetch(variables);
  }, 300), [current, reviewsData]);

  const { reviewsData, reviewsData: { userReviews }, pendingData, loadMore, loadMoreListing, isReviewLoading, isListLoading } = props;
  const { formatMessage } = useIntl();
  return (
    <div className={cx('reviews', s.reviewPanel)}>
      <ul className={cx('list-inline', s.tabs)}>
        <li className={current === 'others' ? s.active : ''}>
          <a className={cx(s.tabItem)} onClick={() => handleClick('others')}>
            <FormattedMessage {...messages.reviewsToWrite} />
          </a>
        </li>
        <li className={current === 'me' ? s.active : ''}>
          <a className={cx(s.tabItem)} onClick={() => handleClick('me')}>
            <FormattedMessage {...messages.writtenReviews} />
          </a>
        </li>
        <li className={cx(s.reviewEditProfile, 'reviewEditProfileRTL')}>
          <Link to={"/user/edit"}>
            <FormattedMessage {...messages.editProfile} />
            <LinkIndicateIcon className={cx(s.editProfileArrow, 'editProfileArrowRTL')} />
          </Link>
        </li>
      </ul>
      {current === 'me' && userReviews && userReviews.totalCount > 0 && <div className={s.searchBox}>
        <input placeholder={formatMessage(messages.searchReviews)} type="" className={cx(s.searchReviewInput, 'searchReviewInputRTL')} onChange={(e) => debounce(handleSearchChange(e.target && e.target.value))} />
      </div>}

      {current === 'others' && <WriteReviews data={pendingData} loadMoreListing={loadMoreListing} isListLoading={isListLoading} />}
      {current === 'me' && <PastReviews data={reviewsData} loadMore={loadMore} searchKey={searchKey} isReviewLoading={isReviewLoading} />}

    </div>
  );
}

ReviewsByYou.propTypes = {
  reviewsData: PropTypes.shape({
    loading: PropTypes.bool,
    formatMessage: PropTypes.any,
    userReviews: PropTypes.array,
    refetch: PropTypes.any
  }),
  pendingData: PropTypes.shape({
    loading: PropTypes.bool,
    pendingReviews: PropTypes.array
  }),
  loadMore: PropTypes.any.isRequired
};

ReviewsByYou.defaultProp = {
  reviewsData: {
    loading: true
  },
  pendingData: {
    loading: true
  }
};
export default injectIntl(withStyles(s)(ReviewsByYou));
